/**
 * Check for CSS purposes only
 *
 * @return {boolean} True if userAgent contains windows, false if not
 */
export const isWindows = () => {

    const userAgent = navigator?.userAgentData?.platform || navigator.userAgent || '';

    return userAgent.toLowerCase().includes('windows');
};
